export enum status_code {
    route_not_exists = -2,
    error = -1,
    success = 0,
    bad_request = 1,
    no_data_found = 2,
    duplicate = 3,
    invalid_credentials = 4,
    expired = 5,
    invalid = 6,
    processed = 7,
    insufficient_credits = 8,
    max_attemps = 9,
    jwt_no_token = 20,
    jwt_invalid = 21,
    jwt_role = 22,
    wp_transaction_not_ini = 100,
    wp_transaction_error_commit_1 = 101,
    wp_transaction_error_commit_2 = 102,
    wp_transaction_error_commit_3 = 103,
    wp_transaction_error_commit_4 = 104,
    wp_transaction_error_commit_5 = 105,
    ask_validation = 106,
    environment_not_configured = 107,
}

export enum status_message {
    route_not_exists = 'Route does not exist',
    error = 'ERROR',
    success = 'SUCCESS',
    bad_request = 'Bad request',
    no_data_found = 'No data found',
    duplicate = 'Record duplicate',
    invalid_credentials = 'Invalid credentials',
    expired = 'Expired',
    invalid = 'Invalid',
    processed = 'Already processed',
    insufficient_credits = 'Insufficient credits',
    max_attemps = 'Max attemps',
    jwt_no_token = 'No token provided',
    jwt_invalid = 'Invalid token',
    jwt_role = 'Insufficient privileges',
    wp_transaction_not_ini = 'Webpay not INITIALIZED',
    wp_transaction_error_commit_1 = 'Rechazo - Posible error en el ingreso de datos de la transacción',
    wp_transaction_error_commit_2 = 'Rechazo - Se produjo fallo al procesar la transacción, este mensaje de rechazo se encuentra relacionado a parámetros de la tarjeta y/o su cuenta asociada',
    wp_transaction_error_commit_3 = 'Rechazo - Error en Transacción',
    wp_transaction_error_commit_4 = 'Rechazo - Rechazada por parte del emisor',
    wp_transaction_error_commit_5 = 'Rechazo - Transacción con riesgo de posible fraude',
    ask_validation = 'Ask for validation',
    environment_not_configured = 'Environment not configured',
}
